import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categoryName: string;
  publishedAt: string;
  views: number;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  category,
  categoryName,
  publishedAt,
  views,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer transition-all hover:border-primary-200/70">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            title={`${title} - 黑料网吃瓜`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{publishedAt}</span>
          <span className="text-xs text-foreground-400 flex items-center gap-1 ml-auto">
            <i className="ri-eye-line"></i>
            {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
          </span>
        </div>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-1.5 flex-wrap">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded bg-background-100 text-foreground-500 whitespace-nowrap"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}